import { render } from "./DashboardClientSummary.vue?vue&type=template&id=844f5a7a&scoped=true"
import script from "./DashboardClientSummary.vue?vue&type=script&lang=js"
export * from "./DashboardClientSummary.vue?vue&type=script&lang=js"

import "./DashboardClientSummary.vue?vue&type=style&index=0&id=844f5a7a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-844f5a7a"]])

export default __exports__